// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/contact-id-mapping-schema',
  type: 'object',
  required: ['id', 'creatorId', 'foreignAppSystemId', 'crmStateId'],
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    crmId: {
      type: 'string',
      format: 'uuid',
    },
    foreignAppSystemId: {
      type: 'integer',
    },
    foreignId: {
      type: 'string',
      nullable: true,
    },
    crmStateId: {
      type: 'integer',
    },
    crmStateName: {
      type: 'string',
      nullable: true,
    },
    mappingStateId: {
      type: 'integer',
      nullable: true,
    },
    mappingStateName: {
      type: 'string',
      nullable: true,
    },
    mappingStateReason: {
      type: 'string',
      nullable: true,
    },
    currentContactData: {
      type: 'string',
      nullable: true,
    },
    previousContactData: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
